export default "__VITE_ASSET__KC$ScRIN__"